import type { App } from '@grafikr/components';

// import Cart from 'utils/cart';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default (_: App) => {
  /*const getCart = () => {
    Cart.get({
      success: (body) => {
        theme.cart = body;

        context.dispatchEvent('cart:fetched', body);
      },
    });
  };

  document.addEventListener('cart:added', getCart);
  document.addEventListener('cart:updated', getCart);*/
};
